import { animationVerticalMessageBlock, animationVerticalMessageNone } from './animation';

window.sortMessage = () =>{
    let top = 20;
    let messages = document.querySelectorAll('.ldc-message-new');
    for (let index = 0; index < messages.length; index++) {
        messages[index].style.top = top + 'px';
        top += 10;
        top += messages[index].offsetHeight;
    }
}

let messageDiv = (classDetect ,message, classType, title, icon, top) => {
    return `<div class="${classDetect} ldc-message-new position-fixed ${classType}" style="top: ${top}px;">
                <div class="d-flex message">
                    <div class="icon-message">
                        ${icon}
                    </div>
                    <div class="content">
                        <div class="title">
                            ${title}
                        </div>
                        <div class="content-message">
                            ${message}
                        </div>
                    </div>
                </div>
            </div>`;
}

Vue.prototype.$message = (data) => {
    let message = data.message;
    // lấy vị trí top
    let top = checkMessage();

    let type = data.type;
    let dataType = '';
    let icon = '<i class="icon ion-md-information-circle"></i>';
    // check type gắn class
    if(type == 'success'){
        dataType = 'ldc-message-success';
        icon = '<i class="icon ion-ios-checkmark-circle"></i>';
    }else if(type == 'warning'){
        dataType = 'ldc-message-warning';
        icon = '<i class="icon ion-md-alert"></i>';
    }else if(type == 'error'){
        dataType = 'ldc-message-danger';
        icon = '<i class="icon ion-ios-close-circle"></i>';
    }

    // lấy tiêu đề
    let title = '';
    if(typeof(data.title) != 'undefined'){
        title = data.title;
    }else if(typeof(Vue.prototype.$titleMessage) != 'undefined'){
        title = Vue.prototype.$titleMessage;
    }else{
        title = 'Notification';
    }

    
    let classDetect = 'ldc-message-web';
    if(Vue.prototype.$detect != 'web'){
        classDetect = 'ldc-message-mobile';
    }

    // lấy body
    let body = document.querySelector('body');
    // thêm mới thông báo vào cuối body
    body.insertAdjacentHTML('beforeend', messageDiv(classDetect, message, dataType, title, icon, top));
    
    //animation message
    animationVerticalMessageBlock();
    // set interval để tắt message
    let timeOut = 2000;
    if(data.timeOut){
        timeOut = data.timeOut;
    }
    setTimeout(() => {
        let messagesAll = document.querySelectorAll('.ldc-message-new');
        if(messagesAll.length > 0){
            let mes = messagesAll[0];
            if(messagesAll.length == 1){
                if(mes){
                    animationVerticalMessageNone(mes, () => {
                        mes.remove();
                    });
                    return;
                }
            }else{
                if(mes){
                    mes.remove();
                    sortMessage();
                }
            }
        }
    }, timeOut)
}

let checkMessage = () => {
    let top = 20;
    let messages = document.querySelectorAll('.ldc-message-new');
    for (let index = 0; index < messages.length; index++) {
        top += 10;
        top += messages[index].offsetHeight;
    }
    return top;
}